<template>
  <div>
    <div class="homeShop" v-if="$store.state.webNavigator=='pc'">
      <div class="home-shop marginAuto max1720">
        <div>
          <p class="part-title list-tlt displayIB" style="width: 100%;color: #ffffff">
            3大保障·脂玫乐健康瘦身值得您托付
          </p>
        </div>
        <div>
          <div class="swiper-container banner4 home-team-bar home-rol">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in rolllist3" :key="index">
                <img class="home-team-img" :src="item" alt="3大保障·脂玫乐健康瘦身值得您托付" title=""/>
              </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="homeShop" v-else>
      <div class="home-shop marginAuto">
        <div class="PhoneHome-title">3大保障 <span class="col00CDA2">-</span> <br> 脂玫乐健康瘦身值得您托付 </div>
        <div>
          <div class="swiper-container banner4 home-team-bar home-rol">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in rolllist3Phone" :key="index">
                <img class="home-team-img" :src="httptype(item)" alt="3大保障·脂玫乐健康瘦身值得您托付" title=""/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myFun } from "../../../../plug/modifyImagePath"
export default {
  name: 'homeShop',
  props: {
    loadType: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      imgUrl: 'https://jusexcx.zmelo.com/',
      rolllist3: myFun([
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/nav3-1.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/nav3-2.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/nav3-3.png',
      ]),
      rolllist3Phone: myFun([
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/NavImg3-1.jpg',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/NavImg3-2.jpg',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/NavImg3-3.jpg',
      ]),
    };
  },
  methods: {
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return url;
        }
      }
      return '';
    },
    initSwiper4 () {
      this.$store.dispatch('getSwiper', () => {
        // 广告轮播图
        this.banner4 = new Swiper('.banner4', {
          loop: true,
          autoHeight: true,
          autoplay: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      });
    },
    initSwiper5 () {
      this.$store.dispatch('getSwiper', () => {
        // 广告轮播图
        this.banner4 = new Swiper('.banner4', {
          loop: true,
          autoHeight: true,
          autoplay: true,
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          // pagination: {
          //   el: '.swiper-pagination',
          // },
        });
      });
    },
  },
  mounted () {
    this.$store.state.webNavigator == 'pc' ? this.initSwiper4() : this.initSwiper5();
  },
};
</script>

<style lang="less" scoped>
  @import url('../../../../../static/css/fontSize.less');

  @media screen and (max-width: 800px) {
    .PhoneHome-title{
      margin-bottom: 37*@width1;
    }
    .home-shop {
      padding: 63*@width1 0 0;
    }

    .home-team {
    }

    .home-team-bar {
      width: 100%;
      height: 617*@width1;
    }

    .home-team-img {
      width: 100%;
      height: 617*@width1;
    }
  }

  @media screen and (min-width: 800px) {
    .homeShop {
      background: #00D2A6;
      padding: 38*@width 0 34.5*@width 0;
    }

    .home-shop, .home-team-img {
      width: 700*@width;
    }

    .home-team {
      padding: 0 50*@width;
    }

    .home-team-bar {
      margin-top: 23*@width;
    }

    .home-team-img {
      height: 255.5*@width;
    }
  }

</style>
<style lang="less">
  @import url('../../../../../static/css/fontSize.less');
  @media screen and (min-width: 800px) {
    .swiper-pagination-bullet {
      width: 22.5 * @width;
      height: 5 * @width;
      background: #B0B0B0;
      border-radius: 3 * @width;
    }

    .swiper-pagination-bullet-active {
      background: #00CDA2;
    }
  }

</style>



// WEBPACK FOOTER //
// homeShop.vue